module.exports = __webpack_public_path__ + "img/i.801b3c6f.jpg";